var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3476_2269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66675C8.4529 1.66675 6.96917 2.28133 5.87521 3.37529C4.78125 4.46925 4.16667 5.95299 4.16667 7.50008V10.4401C4.16679 10.5694 4.13683 10.6969 4.07917 10.8126L2.64833 13.6734C2.57844 13.8132 2.54543 13.9685 2.55246 14.1246C2.55948 14.2807 2.60629 14.4324 2.68845 14.5654C2.77061 14.6983 2.88539 14.808 3.02189 14.8841C3.15838 14.9602 3.31206 15.0001 3.46833 15.0001H16.5317C16.6879 15.0001 16.8416 14.9602 16.9781 14.8841C17.1146 14.808 17.2294 14.6983 17.3115 14.5654C17.3937 14.4324 17.4405 14.2807 17.4475 14.1246C17.4546 13.9685 17.4216 13.8132 17.3517 13.6734L15.9217 10.8126C15.8637 10.697 15.8335 10.5694 15.8333 10.4401V7.50008C15.8333 5.95299 15.2188 4.46925 14.1248 3.37529C13.0308 2.28133 11.5471 1.66675 10 1.66675ZM10 17.5001C9.48282 17.5002 8.97831 17.34 8.55596 17.0415C8.1336 16.7431 7.81418 16.321 7.64167 15.8334H12.3583C12.1858 16.321 11.8664 16.7431 11.444 17.0415C11.0217 17.34 10.5172 17.5002 10 17.5001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3476_2269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.501d6a7fce4bd21973b1b55fe9eb7857.svg";
export { ForwardRef as ReactComponent };